import { IPrepareIndividualData } from "../../../slices/NotificationSlice";
import { ISSOUser, ISwitchRole } from "../../../slices/UserSlice";
import {
  LEVEL_CONSTANT,
  SSO_ROLE_CONSTANT,
  STATUS_CONSTANT,
} from "../modal/CreateAndEditNotify/FormDataConstants";
import { MSG_CONSTANTS } from "./msgConstants";

export const getSubmitButtonTooltip = (
  data: IPrepareIndividualData | null,
  user: ISSOUser | null,
  switchRole: ISwitchRole
) => {
  if (!user || !data) {
    return MSG_CONSTANTS.ERRORS.INSUFFICIENT_DATA;
  }
  if (data?.status !== STATUS_CONSTANT.draft) {
    return MSG_CONSTANTS.ERRORS.NON_DRAFT_STATUS;
  }
  if (user?.email !== data.createdBy.name) {
    return MSG_CONSTANTS.ERRORS.CREATOR_ONLY;
  }
  if (
    data?.level !== LEVEL_CONSTANT.level2 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.broadCast
  ) {
    return MSG_CONSTANTS.ERRORS.NO_LEVEL_ACCESS;
  }
  return MSG_CONSTANTS.ACTIONS.SUBMIT;
};

export const getPublishBtnTooltip = (
  data: IPrepareIndividualData | null,
  user: ISSOUser | null,
  switchRole: ISwitchRole,
  isExpired: boolean
) => {
  if (!user || !data) {
    return MSG_CONSTANTS.ERRORS.INSUFFICIENT_DATA;
  }
  if (isExpired && data.level !== LEVEL_CONSTANT.level2) {
    return MSG_CONSTANTS.ERRORS.EXPIRED_NOTIFICATION;
  }
  if (isExpired && data.level === LEVEL_CONSTANT.level2) {
    return MSG_CONSTANTS.ACTIONS.PUBLISH_EXPIRED_LEVEL2;
  }
  if (user?.email !== data.assignedUser[0]) {
    return MSG_CONSTANTS.ERRORS.ASSIGNED_USER_ONLY;
  }
  if (
    data?.level !== LEVEL_CONSTANT.level2 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.broadCast
  ) {
    return MSG_CONSTANTS.ERRORS.NO_LEVEL_ACCESS;
  }
  if (
    data.level !== LEVEL_CONSTANT.level1 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.admin
  ) {
    return MSG_CONSTANTS.ERRORS.ADMIN_NO_LEVEL_ACCESS;
  }
  return MSG_CONSTANTS.ACTIONS.PUBLISH;
};

export const getRejectBtnTooltip = (
  data: IPrepareIndividualData | null,
  user: ISSOUser | null,
  switchRole: ISwitchRole,
  isExpired: boolean
) => {
  if (!user || !data) {
    return MSG_CONSTANTS.ERRORS.INSUFFICIENT_DATA;
  }
  if (isExpired) {
    return MSG_CONSTANTS.ACTIONS.REJECT;
  }
  if (user?.email !== data.assignedUser[0]) {
    return MSG_CONSTANTS.ERRORS.ASSIGNED_USER_ONLY;
  }
  if (
    data?.level !== LEVEL_CONSTANT.level2 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.broadCast
  ) {
    return MSG_CONSTANTS.ERRORS.NO_LEVEL_ACCESS;
  }
  if (
    data.level !== LEVEL_CONSTANT.level1 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.admin
  ) {
    return MSG_CONSTANTS.ERRORS.ADMIN_NO_LEVEL_ACCESS;
  }
  return MSG_CONSTANTS.ACTIONS.REJECT;
};

export const getAssignBtnTooltip = (
  data: IPrepareIndividualData | null,
  user: ISSOUser | null,
  switchRole: ISwitchRole
) => {
  if (!user || !data) {
    return MSG_CONSTANTS.ERRORS.INSUFFICIENT_DATA;
  }
  if (
    data?.level !== LEVEL_CONSTANT.level2 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.broadCast
  ) {
    return MSG_CONSTANTS.ERRORS.NO_LEVEL_ACCESS;
  }
  if (data.assignedUser.length > 0) {
    return MSG_CONSTANTS.ACTIONS.REASSIGN;
  }
  if (
    data.level !== LEVEL_CONSTANT.level1 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.admin
  ) {
    return MSG_CONSTANTS.ERRORS.ADMIN_NO_LEVEL_ACCESS;
  }
  return MSG_CONSTANTS.ACTIONS.ASSIGN;
};

export const getRecallBtnTooltip = (
  data: IPrepareIndividualData | null,
  user: ISSOUser | null,
  switchRole: ISwitchRole
) => {
  if (!user || !data) {
    return MSG_CONSTANTS.ERRORS.INSUFFICIENT_DATA;
  }
  if (
    data?.level !== LEVEL_CONSTANT.level2 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.broadCast
  ) {
    return MSG_CONSTANTS.ERRORS.NO_LEVEL_ACCESS;
  }
  if (
    data.level !== LEVEL_CONSTANT.level1 &&
    switchRole.activeRole === SSO_ROLE_CONSTANT.admin
  ) {
    return MSG_CONSTANTS.ERRORS.ADMIN_NO_LEVEL_ACCESS;
  }
  return MSG_CONSTANTS.ACTIONS.RECALL;
};
